// extracted by mini-css-extract-plugin
export default {"wrapper":"Photos_wrapper__ZM7IU","avatar":"Photos_avatar__J+Lf5","avatarImg":"Photos_avatarImg__yFyp1"};